import ajax from '../utils/ajax'
import config from '@/config'

const LOGS_ACTION = '/apps/logs/action'

export default class PreviewLog {
  /**
     * 判断当前预览类型是否支持预览日志上报，目前只统计wps与pdf
     * @param {String} kind 当前预览类型
     */
  static needLog (kind) {
    return kind === 'wps' || kind === 'pdf' || kind === 'pdf_enc' || kind === 'pspdfkit'
  }

  static succeed (fileId, time) {
    let data = {
      'action': 'preview_complete',
      'additional_info': { },
      'uuid': new Date().getTime(),
      'typed_id': fileId,
      'source': 'h5'
    }

    data.additional_info = {
      'status': 'generated',
      'time': time
    }

    ajax({
      url: LOGS_ACTION,
      data,
      accept_all_errors: true
    })
  }

  static previewError (fileId, time, failReason) {
    let data = {
      'action': 'preview_complete',
      'additional_info': { },
      'uuid': new Date().getTime(),
      'typed_id': fileId,
      'source': 'h5',
      'fail_reason': failReason
    }

    data.additional_info = {
      'status': 'preview_failed',
      'time': time,
      'fail_reason': 'preview_failed'
    }

    ajax({
      url: LOGS_ACTION,
      data,
      accept_all_errors: true
    })
  }

  static transformError (fileId, time, failReason) {
    let data = {
      'action': 'preview_complete',
      'additional_info': { },
      'uuid': new Date().getTime(),
      'typed_id': fileId,
      'source': 'h5'
    }

    data.additional_info = {
      'status': 'transform_failed',
      'time': time,
      'fail_reason': failReason
    }

    ajax({
      url: LOGS_ACTION,
      data,
      accept_all_errors: true
    })
  }

  static notSupportError (fileItem, preview_kind, time) {
    let data = {
      'action': 'preview_complete',
      'additional_info': { },
      'uuid': new Date().getTime(),
      'typed_id': fileItem.id,
      'source': 'h5'
    }

    let enterpriseId = 0
    if (config.enterprise_info) {
      enterpriseId = config.enterprise_info.id
    }

    data.additional_info = {
      'status': 'not_support',
      'time': time,
      'fail_reason': 'not_support',
      'enterprise_id': enterpriseId,
      'extension': fileItem.extension,
      'size': fileItem.size,
      'preview_kind': preview_kind
    }

    ajax({
      url: LOGS_ACTION,
      data,
      accept_all_errors: true
    })
  }
}
